import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipPaymentType = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    A forma de pagamento será gerenciada de acordo com a opção escolhida na criação da fatura. <br />
                    <br />
                    <b>Automático (Produttivo)</b>: O próprio sistema envia a fatura ao cliente, acompanha o pagamento e atualiza o status. Você não precisa fazer nada. <br />
                    <br />
                    <b>Manual (Outros bancos)</b>: Você é quem envia a fatura ao cliente, acompanha o pagamento e atualiza o status manualmente. <br />
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipPaymentType;